import "./portfolio.scss";
import PortfolioList from "../portfolioList/PortfolioList";
import {useState, useEffect} from "react";
import {
    companyProjets,
    learningProjects,
    freelancingProjects,
} from "../../data";

export default function Portfolio(){
    const [selected, setSelected] = useState("company");
    const [data, setData] = useState([]);

    const list = [
        {
            id: "company",
            title: "Company",
          },
          {
            id: "learning",
            title: "Learning",
          },
          {
            id: "freelancing",
            title: "Freelancing",
          },
    ];

    
    useEffect(() => {

        switch (selected) {
            case "company":
              setData(companyProjets);
              break;
            case "learning":
              setData(learningProjects);
              break;
            case "freelancing":
              setData(freelancingProjects);
              break;
            default:
              setData(companyProjets);
          }

    }, [selected]);

    return(
        <div className="portfolio" id="portfolio">
            <h1>Projects</h1>
            <ul>
               {
                   list.map((item) => {
                       return (
                        <PortfolioList title={item.title} 
                            active={selected === item.id}
                            setSelected={setSelected}
                            id={item.id}
                        />
                       )
                   })
               }
            </ul>

            <div className="container">
                
                {
                    data.map((d) => {
                        return(
                            <a href={d.link} target="_blank">
                                <div className="item">
                                    <img src={d.img} alt=""/>
                                    <h3>{d.title}</h3>
                                </div>
                            </a>
                        );
                    })
                }


            </div>

        </div>
    )
}